// extracted by css-extract-rspack-plugin
export default {"Link":"UserBlockedEvent-module__Link__Co35MjL"};